import { Camera } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { Hero } from "@/components/site/Hero";
import { PageShell } from "@/components/site/PageShell";
import { ContactAside } from "@/components/site/ContactAside";
import { DamageForm } from "@/components/inquiry/DamageForm";
import { breadcrumbLd } from "@/lib/jsonld";

const crumbs = [{ label: "Schaden melden", to: "/schaden-melden" }];

export default function DamagePage() {
  return (
    <>
      <Seo
        title="Schaden online melden – Kfz-Gutachter Köln | Marcone"
        description="Unfallschaden online melden: Daten eingeben, Fotos direkt vom Handy hochladen – wir melden uns meist innerhalb von 30 Minuten. Kostenlos bei unverschuldetem Unfall."
        path="/schaden-melden"
        jsonLd={[breadcrumbLd(crumbs)]}
      />
      <PageShell
        aside={<ContactAside />}
        asideFirstOnMobile={false}
        hero={
          <Hero
            image="real-marcone-buero"
            imagePosition="center 30%"
            imageAlt="Francesco Marcone prüft Schadensfotos am Bildschirm in seinem Büro in Köln"
            eyebrow="In 2 Minuten erledigt"
            title="Schaden online melden"
            subtitle="Angaben eintragen, Fotos hochladen – wir melden uns meist innerhalb von 30 Minuten."
            breadcrumbs={crumbs}
          />
        }
      >
        <div className="rounded-3xl bg-white p-6 shadow-soft ring-1 ring-slate-200 sm:p-8" data-testid="damage-page-card">
          <div className="mb-6 flex items-center gap-3">
            <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-yellow text-brand-anthracite"><Camera className="h-5 w-5" /></span>
            <div>
              <h2 className="text-xl font-bold text-brand-anthracite">Ihre Schadenmeldung</h2>
              <p className="text-sm">Pflichtfelder sind mit * markiert.</p>
            </div>
          </div>
          <DamageForm prefix="damage-page" wide />
        </div>
      </PageShell>
    </>
  );
}
